export const handleDownload = (downloadQuoteUrl: string): void => {
  fetch(downloadQuoteUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error("Error fetching the file");
      }
      return response.blob();
    })
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "downloaded-file.pdf";
      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    })
    .catch(error => {
      console.error(error);
    });
};
